import React from "react";
import { Badge } from "src/components/ui/badge";

const STATUS_COLORS = {
  // Common property status
  draft: "bg-slate-100 text-slate-700 hover:bg-slate-200",
  active: "bg-blue-100 text-blue-700 hover:bg-blue-200",
  under_offer: "bg-amber-100 text-amber-700 hover:bg-amber-200",
  sold: "bg-green-100 text-green-700 hover:bg-green-200",
  withdrawn: "bg-red-100 text-red-700 hover:bg-red-200",
  rented: "bg-purple-100 text-purple-700 hover:bg-purple-200",

  // Buyer requirement status
  paused: "bg-slate-100 text-slate-700 hover:bg-slate-200",
  fulfilled: "bg-green-100 text-green-700 hover:bg-green-200",
  expired: "bg-red-100 text-red-700 hover:bg-red-200",
};

export function PropertyStatusBadge({ status, className = "" }) {
  if (!status) return null;
  const colorClass =
    STATUS_COLORS[status.toLowerCase()] ||
    "bg-slate-100 text-slate-700 hover:bg-slate-200";

  // e.g. "under_offer" -> "Under offer"
  const formattedStatus = status.replace(/_/g, " ");

  return (
    <Badge
      variant="secondary"
      className={`capitalize font-medium px-2 py-0.5 text-xs ${colorClass} ${className}`}
    >
      {formattedStatus}
    </Badge>
  );
}
